import React, { useEffect, useState } from "react";

import { CustomButton } from "../../../components/main_comps/custom_button";

import { useDispatch, useSelector } from "react-redux";

import { useSnackbar } from "notistack";
import secureStorage from "../../../../services/secureStorage";
import { SS_INTERNAL, SS_ROLE } from "../../../../utility/constants/secureStorageManager";
import { APPROVED, STATUS_CODE_200 } from "../../../../utility/constants/valueConstants";

import CustomTable from "../../../components/main_comps/custom_table";
import ResizeListner from "../../../../utility/ResizeListner";
import { setHeaders } from "../../../../services/aclValidateServiceTable";
import { ChargeBackHeaders } from "../../../../utility/TableHeaders";
import { fecthClientList } from "../../../../services/fetchListingData";

import { ApiRequestPost } from "../../../../data/network/services/ApiRequestPost";
import { CustomLoader } from "../../../components/main_comps/custom_loader";
import { useNavigate } from "react-router";

import Search from "antd/es/input/Search";

const ChargeBackTableClient = ({ spName, onCloseModal }) => {

    console.log(spName, "spName");

    const { height } = ResizeListner();
    const clientListData = useSelector((state) => state.listingSlice.clientList);
    const aclData = useSelector((state) => state.aclSlice.aclList);
    const internal = secureStorage.getItem(SS_INTERNAL);
    const dispatch = useDispatch();

    // const [chargeBackHold, setchargeBackHold] = useState("100")
    // const [chargeBackRelease, setchargeBackRelease] = useState("100")

    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    // const [clientListData, setClientListData] = useState(null);
    const [inputValues, setInputValues] = useState([]);

    console.log(inputValues, "inputValues");

    const handleInputChange = (e, _id, key) => {
        console.log(e, _id, key, "---<<<>")
        const value = e.target.value;
        console.log(value, "<<<<-------value");


        let newArr = inputValues?.map((client) => {
            if (client.userId == _id) {
                console.log(client, "client--dddd")
                let newClient = { ...client };
                newClient[key] = value;
                console.log(newClient, "newClient");
                return newClient;
            } else {
                return client
            }
        });

        setInputValues(newArr);

        console.log(newArr, "-------newArr")
    };

    function refreshPage() {
        window.location.reload();
    }

    const { enqueueSnackbar } = useSnackbar();

    useEffect(() => {
        // fetchClientList();
        console.log(clientListData?.clients)
        setInputValues(clientListData?.clients)

    }, [clientListData?.clients, spName]);

    const [searchQuery, setSearchQuery] = useState('');

    useEffect(() => {
        if (spName) {
            dispatch(
                fecthClientList(
                    {
                        page: 0,
                        size: 10,
                        userRefId: "",
                        onBoardedStatus: APPROVED,
                        serviceProviderName: spName,
                        businessName: searchQuery,

                    })
            );
        }

    }, [ searchQuery]);

    const handleSearchChange = (event) => {
        setSearchQuery(event.target.value);
    };


    const handleUploadChargeBack = () => {
        if (!Array.isArray(inputValues)) {
            console.error("Input values must be an array.");
            return;
        }

        const chargeBackArr = inputValues.map((item) => {
            const { userId, chargeBackHold, chargeBackRelease } = item;
            return { userId, chargeBackHold, chargeBackRelease };
        });

        setLoading(true);

        console.log(chargeBackArr, "----chargeBackArr");

        ApiRequestPost.addChargeBack(chargeBackArr)
            .then(response => {
                if (response.statusCode === STATUS_CODE_200) {
                    console.log("Charge back uploaded successfully:", response);
                    enqueueSnackbar('Charge back uploaded successfully', { variant: 'success' });
                    onCloseModal(true);
                    setTimeout(() => {
                        refreshPage();
                    }, 500);
                    return { success: true, response };
                } else {
                    console.error("Error uploading charge back:", response);
                    enqueueSnackbar('Error uploading charge back', { variant: 'error' });
                    return { success: false, response };
                }
            })
            .catch(error => {
                console.error("Error uploading charge back:", error);
                enqueueSnackbar('Error uploading charge back', { variant: 'error' });
                return { success: false, error };
            }).finally(() => {
                setLoading(false);




            })
    };





    return (
        <>
            {loading && <CustomLoader />}
            <nav>







                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "10px 20px" }}>

                    <Search
                        placeholder="Search Business Name"
                        title="Upload"
                        backgroundColor="#38369C"
                        styles={{ color: "white", marginLeft: "10px", padding: "10px 20px", borderRadius: "5px" }}
                        // onClick={handleUploadChargeBack}
                        onChange={handleSearchChange}
                        className="w-[350px]"
                        allowClear

                    />
                    <CustomButton
                        title="Upload"
                        backgroundColor="#38369C"
                        styles={{ width: 150, color: "white", marginLeft: "10px" }}
                        onClick={handleUploadChargeBack}

                    />
                </div>
            </nav>

            <div
                style={{
                    maxHeight: 500,
                    overflow: "scroll",
                    position: "relative",
                }}
                className="hide-scroll-bar"
            >

                <div
                    style={{ width: "100%", maxHeight: 600, overflow: "auto" }}
                    className="hide-scroll-bar"
                >

                    <div style={{ padding: "0px 20px", overflow: "hidden" }}>
                        <CustomTable
                            styles={{
                                maxHeight: height * 0.7,
                                minHeight: height * 0.7,
                            }}
                            data={inputValues}
                            headers={setHeaders(ChargeBackHeaders, aclData, internal)}
                            //clientListData?.totolRecords
                            totalElements={clientListData?.totalRecords}
                            currentPage={clientListData?.currentPageNo - 1}
                            //clientListData?.totalPages
                            totalPages={clientListData?.totalPages}
                            handlePaginate={(page) => {
                                dispatch(
                                    fecthClientList(
                                        {
                                            page: page + 1,
                                            size: 10,
                                            userRefId: "",
                                            onBoardedStatus: APPROVED,
                                            serviceProviderName: spName,
                                            businessName: searchQuery,
                                        })
                                );
                            }}
                            handleInputChange={handleInputChange}

                        />
                    </div>

                </div>

            </div>
        </>
    );
};

export default ChargeBackTableClient;
